import Edit from './_Edit'

export default Edit
